import axios from "axios";
import {ordersServicesPath} from "../../../../Constants";

const restUrl = ordersServicesPath + '/organizations/requests-cutting'

/** API заявок на раскрой только для заказов-композиций (орг.). */
export default class CompositionRequestsCuttingService {
    static async getAllByOrderId(orderId) {
        return axios.get(`${restUrl}/by-order-id-for-cloud?orderId=${orderId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        return axios.delete(`${restUrl}/${id}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
